import React from 'react'
import CartProduct from '../CartProduct'
import { CartMenuWrapper } from './index.styled'
import Currency from '../../../currency'
import PlusMinus from '../PlusMinus'
import { useLocalStorage } from '../../../../../hooks/useLocalStorage'
import { CartProductDishCourseWrap, CartProductWrap, DisabledProgress, Product, ProductCol, ProductDiscountPrice, ProductMessageText, ProductName, ProductNr, ProductPrice, ProductQuantity, ProductToppings, ProductTotal } from '../CartProduct/index.styled'
import { calcCartItemTotalPrice } from '../../../../../helper'
import CartRemark from '../CartRemark'
import { useSelector } from 'react-redux'
import { selectDiscountForItem } from '../../../../../redux/selector/cart'
import CartDishCourse from '../CartDishCourse'
import { useTranslation } from 'react-i18next'
import BackInfo from '../BackInfo'

const CartMenu = React.memo(({ active, item, removeAbility = true, onClick, onClickPlus, onClickMinus, AddButton, handleRemoveRemark, savedOrder, enabledDishCourse, onClickProduct, disabled, onClickInfo, onClickBack, module }) => {
	const { t } = useTranslation()
	const [touchPad] = useLocalStorage('touchPad', false)
	const totalPrice = item ? calcCartItemTotalPrice(item) : 0
	const discount = useSelector(selectDiscountForItem(totalPrice, item))
	const layout = (touchPad ? 'touchPad ' : '') + (active ? 'active' : '') + (savedOrder ? ' secondary' : '') + (disabled ? ' disabled' : '')
	const isCanceledItem = ['CANCELED', 'PREPARED_TO_CANCEL'].includes(item?.status)
	const layoutWrap = `${active ? 'active' : ''} ${touchPad ? 'touchPad' : ''} ${isCanceledItem ? ' strikethrough' : ''} ${item?.dishCourse ? ' dishCourse' : ''}` + (disabled ? ' disabled' : '')
	const itemHasDiscount = discount > 0 && !item?.disabledDiscount
	const itemHasDishCourse = enabledDishCourse || item?.dishCourse

	const discountedPrice = itemHasDiscount ? totalPrice - discount : totalPrice
	const layoutPrice = (itemHasDiscount ? 'green ' : '')
	const layoutDishCourseWrap = (itemHasDishCourse ? 'lf-col-2' : '') + (active ? ' active' : '') + ' menu' + (disabled ? ' disabled' : '')

	return (
		<CartProductDishCourseWrap className={layoutDishCourseWrap} onClick={onClick}>
			{itemHasDishCourse && <CartDishCourse item={item} savedOrder={savedOrder} />}
			<CartProductWrap className={layoutWrap} onClick={onClickProduct} data-testid="item-menu">
				<Product className={layout}>
					{disabled && <ProductMessageText>{t('Cart.disableItemMessage')}</ProductMessageText>}
					<ProductNr className={layout + ' menu'}>{item?.sku}</ProductNr>
					<ProductName className={layout + ' menu'}>
						{item?.name}
						{item?.quantity > 1 &&
							<ProductQuantity className={layout + ' menu'}> x {item?.quantity}</ProductQuantity>}
					</ProductName>
					<ProductCol className={layout + ' menu'}>
						{!disabled && <Currency>{item?.price}</Currency>}
					</ProductCol>
					<ProductTotal className={layout + ' menu'}>
						{!disabled && itemHasDiscount && <ProductDiscountPrice><Currency>{totalPrice}</Currency></ProductDiscountPrice>}
						{!disabled && <ProductPrice className={layoutPrice}><Currency>{discountedPrice}</Currency></ProductPrice>}
					</ProductTotal>
					{!disabled && !isCanceledItem && <PlusMinus {...{ AddButton, onClickPlus, onClickMinus, incrementAbility: true, removeAbility, size: touchPad ? 'x-medium' : '' }} />}
					{isCanceledItem && module === 'RESTAURANT' &&
						<BackInfo {...{ onClickInfo, onClickBack, backAbility: item.status === 'PREPARED_TO_CANCEL', size: touchPad ? 'x-medium' : '' }} />}
				</Product>
				<CartMenuWrapper className={layout} data-testid="menu-products">
					{!disabled && item?.remark &&
						<ProductToppings className={`toppings ${layout}`}>
							<CartRemark remark={item?.remark}
													layout={layout}
													handleRemoveRemark={handleRemoveRemark} />
						</ProductToppings>}
					{item?.items.map((item, i) =>
						<CartProduct key={i}
												 active={false}
												 item={item}
												 isMenuItem={true}
												 removeAbility={false}
												 incrementAbility={false}
												 handleRemoveRemark={handleRemoveRemark}
												 savedOrder={savedOrder}
												 disabled={disabled} />)}
				</CartMenuWrapper>
				{disabled && <DisabledProgress />}
			</CartProductWrap>
		</CartProductDishCourseWrap>

	)
})

CartMenu.displayName = 'CartMenu'
export default CartMenu
